define('components/videofactory/models/YoutubeVideoModel', [

], function() {

    var YoutubeVideoModel = Backbone.Model.extend({
        defaults: {
            viewId: "video-id",                 // Classic default viewId
            videoId: null,                      // Video id on youtube
            videoWidth: 640,                    // Width of video (could be in % or px)
            videoHeight: 380,                   // Height of video (could be in % or px)
            autoplay: 0,                        // Autoplay video
            rel: 0,                             // Show / Hide related videos at the end
            iv_load_policy: 3,                  // TODO CHECK THIS
            modestbranding: 1,                  // Show / Hide Youtube logo
            showInfo: 0,                        // Show / Hide Youtube info
            wmode: "transparent",               // Skin TODO CHECK THIS
            currentTime: -1,                    // Current time of the video (in milliseconds)
            duration: -1                        // Duration of the video (in milliseconds)
        }
    });

    return YoutubeVideoModel;
});
